export default __webpack_public_path__ + "static/media/Balance-Sheet-Template.xlsx";